/**
 * Headline price is the lowest fresh USD store offer. The manual catalog
 * price is the fallback. Catalog prices are never overwritten by the checker.
 *
 * Returns null when no usable price is available.
 */

function formatUsdAmount(amount) {
  return `$${Number(amount).toLocaleString("en-US")}`;
}

export function formatLiveFromPrice(livePrice) {
  if (!livePrice || livePrice.amount == null) return null;
  const amount = Number(livePrice.amount);
  if (!Number.isFinite(amount)) return null;
  if (livePrice.currency !== "USD") return null;
  const formatted = formatUsdAmount(amount);
  return livePrice.storeCount > 1 ? `from ${formatted}` : formatted;
}

export function formatDisplayPrice(product, _region) {
  const live = formatLiveFromPrice(product?.livePrice);
  if (live) return live;

  const usd = Number(product?.price);
  if (!Number.isFinite(usd)) return null;
  return formatUsdAmount(usd);
}

export default formatDisplayPrice;
